import { render } from "./ListeCodificationPage.vue?vue&type=template&id=aa4b065a&ts=true"
import script from "./ListeCodificationPage.vue?vue&type=script&lang=ts"
export * from "./ListeCodificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__